import React from "react";
import PrinterInputs from "./PrinterInputs";
import { usePrinterExtraStore } from "../../state/storePrinterExtra";

type Props = {};

const PrinterRightTextInput = (props: Props) => {
  const {
    printer_right1,
    printer_right2,
    printer_right3,
    printer_right4,
    printer_right5,
    printer_right6,
    printer_right7,
  } = usePrinterExtraStore((state) => state);
  const [printerRight, setPrinterRight] = React.useState({
    printer_right1: '',
    printer_right2: '',
    printer_right3: '',
    printer_right4: '',
    printer_right5: '',
    printer_right6: '',
    printer_right7: '',})
  React.useEffect(() => {
    setPrinterRight({
      printer_right1,
      printer_right2,
      printer_right3,
      printer_right4,
      printer_right5,
      printer_right6,
      printer_right7,
    })
  }, [printer_right1, printer_right2, printer_right3, printer_right4, printer_right5, printer_right6, printer_right7])  
  return (
    <div className="p-2 flex-1 mt-7">
      <span className="text-slate-700 text-lg">Right</span>
      <PrinterInputs
        value={printerRight.printer_right1}
        label="printer_right1"
        type="text"
      />
      <PrinterInputs
        value={printerRight.printer_right2}
        label="printer_right2"
        type="text"
      />
      <PrinterInputs
        value={printerRight.printer_right3}
        label="printer_right3"
        type="text"
      />
      <PrinterInputs
        value={printerRight.printer_right4}
        label="printer_right4"
        type="text"
      />
      <PrinterInputs
        value={printerRight.printer_right5}
        label="printer_right5"
        type="text"
      />
      <PrinterInputs
        value={printerRight.printer_right6}
        label="printer_right6"
        type="text"
      />
      <PrinterInputs
        value={printerRight.printer_right7}
        label="printer_right7"
        type="text"
      />
    </div>
  );
};

export default PrinterRightTextInput;
